import { useState } from "react";
import { logout } from "../../firebase/services";
import OwnerDashboard     from "./OwnerDashboard";
import OwnerRooms         from "./OwnerRooms";
import OwnerTickets       from "./OwnerTickets";
import OwnerPayments      from "./OwnerPayments";
import OwnerListings      from "./OwnerListings";
import OwnerAnnouncements from "./OwnerAnnouncements";
import OwnerCautions      from "./OwnerCautions";
import Chat               from "../../components/Chat";
import NotificationBell   from "../../components/NotificationBell";
import IamLogo            from "../../components/IamLogo";

const TABS = [
  { id: "dashboard",     icon: "🏠", label: "Accueil"    },
  { id: "tickets",       icon: "🔧", label: "Tickets"    },
  { id: "rooms",         icon: "🏢", label: "Chambres"   },
  { id: "payments",      icon: "💳", label: "Paiements"  },
  { id: "cautions",      icon: "🏦", label: "Cautions"   },
  { id: "announcements", icon: "📢", label: "Annonces"   },
];

export default function OwnerApp({ user, profile }) {
  const [tab, setTab]           = useState("dashboard");
  const [chatRoomId, setChatRoomId] = useState(null);

  const handleNavigate = (page, param) => {
    if (page === "chat")          { setChatRoomId(param);      return; }
    if (page === "tickets")       { setTab("tickets");         return; }
    if (page === "payments")      { setTab("payments");        return; }
    if (page === "rooms")         { setTab("rooms");           return; }
    if (page === "listings")      { setTab("listings");        return; }
    if (page === "announcements") { setTab("announcements");   return; }
    if (page === "cautions")      { setTab("cautions");        return; }
  };

  if (chatRoomId) return (
    <div style={S.shell}>
      <Chat
        roomId={chatRoomId}
        currentUser={{ uid: user.uid, role: "owner" }}
        roomLabel="Conversation chambre"
        onBack={() => setChatRoomId(null)}
      />
    </div>
  );

  return (
    <div style={S.shell}>
      <div style={S.header}>
        <IamLogo height={30} />
        <div style={{ flex: 1 }} />
        <NotificationBell userId={user.uid} role="owner" roomId={null} />
      </div>

      <div style={S.content}>
        {tab === "dashboard"     && <OwnerDashboard     onNavigate={handleNavigate} />}
        {tab === "tickets" && <OwnerTickets onNavigate={handleNavigate} currentUserId={user.uid} />}
        {tab === "rooms"         && <OwnerRooms         onNavigate={handleNavigate} />}
        {tab === "payments"      && <OwnerPayments      />}
        {tab === "cautions"      && <OwnerCautions      />}
        {tab === "announcements" && <OwnerAnnouncements />}
        {tab === "listings"      && <OwnerListings      />} 
      </div>

      <div style={S.nav}>
        {TABS.map(t => (
          <button key={t.id}
            style={{ ...S.navBtn, ...(tab === t.id ? S.navOn : {}) }}
            onClick={() => setTab(t.id)}
          >
            <span style={{ fontSize: 18 }}>{t.icon}</span>
            <span style={{ fontSize: 8, marginTop: 1, fontWeight: tab === t.id ? 700 : 400 }}>{t.label}</span>
          </button>
        ))}
        <button style={S.navBtn} onClick={logout}>
          <span style={{ fontSize: 18 }}>🚪</span>
          <span style={{ fontSize: 8, marginTop: 1 }}>Quitter</span>
        </button>
      </div>
    </div>
  );
}

const S = {
  shell:   { display: "flex", flexDirection: "column", height: "100dvh", maxWidth: 480, margin: "0 auto", background: "#f5f8fc" },
  header:  { background: "#1a3a5c", padding: "10px 14px", display: "flex", alignItems: "center", gap: 10 },
  content: { flex: 1, overflowY: "auto", display: "flex", flexDirection: "column" },
  nav:     { display: "flex", background: "white", borderTop: "0.5px solid #d0dce8", paddingBottom: "env(safe-area-inset-bottom)" },
  navBtn:  { flex: 1, display: "flex", flexDirection: "column", alignItems: "center", padding: "6px 1px", background: "none", border: "none", color: "#7a90a8", cursor: "pointer", fontFamily: "inherit" },
  navOn:   { color: "#1a3a5c" },
};
